<template>
  <page-wrapper :title="title + date">
    <div class="container">
      <div class="header">
        <div class="name">ชื่อ</div>
        <div class="count">จำนวนครั้ง</div>
      </div>
      <div class="mb-4">
        <notification-log-row
          v-for="item in notificationStats"
          :key="item.id"
          v-bind="item"
        ></notification-log-row>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import NotificationLogRow from "../components/NotificationLogRow";
import { DateTime } from "luxon";
import { toLocaleTH } from "@/lib/dateTime";

export default {
  components: {
    PageWrapper,
    NotificationLogRow
  },
  data() {
    const date = toLocaleTH(DateTime.utc()).toLocaleString();
    const title = "รายการ Third Party Notification ของวันที่ ";
    const notificationStats = [];

    return { date, title, notificationStats };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    async setupData() {
      await this.setupNotificationStats();
    },
    async setupNotificationStats() {
      const notificationStats = await this.fetchStat();

      this.notificationStats = notificationStats;
    },
    async fetchStat() {
      const response = await baanRueJaiClient.admin.monitorings.thirdPartyNotification.statToday();

      return response.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.container {
  padding-top: $space;
  padding-bottom: $space;
  padding-left: 20%;
  padding-right: 20%;
}

.header {
  display: grid;
  grid-gap: $space;
  grid-template-columns: auto auto;
  align-items: center;

  border-bottom: $border;
  padding: 15px 10px 5px;

  color: #999;
  font-size: 14px;

  > .count {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/monitoring/modules/thirdPartyNotification/pages/ThirdPartyNotificationListPage.vue